import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Network, FileText, FileType2, Download, ExternalLink } from "lucide-react";

const FILES = {
  pdf: "/Aspiritech_Portal_Architecture.pdf",
  docx: "/Aspiritech_Portal_Architecture.docx",
  diagram: "/portal_architecture_diagram.png",
};

const ArchitectureTab = () => {
  return (
    <div className="space-y-6" data-testid="architecture-tab">
      <div className="flex items-center gap-2">
        <Network className="w-5 h-5 text-brand-navy" />
        <h2 className="text-xl font-heading font-bold text-slate-900">System Architecture</h2>
      </div>
      <p className="text-sm text-slate-500 max-w-3xl">
        Technical documentation of the portal — system layers, API domains, data model, integrations, and
        deployment. Download the latest PDF or Word version, or view the architecture diagram below.
      </p>

      <div className="flex flex-wrap gap-3">
        <a href={FILES.pdf} download data-testid="arch-download-pdf">
          <Button className="btn-primary gap-2"><FileText className="w-4 h-4" /> Download PDF</Button>
        </a>
        <a href={FILES.docx} download data-testid="arch-download-docx">
          <Button variant="outline" className="btn-outline gap-2"><FileType2 className="w-4 h-4" /> Download Word</Button>
        </a>
        <a href={FILES.diagram} target="_blank" rel="noopener noreferrer" data-testid="arch-open-diagram">
          <Button variant="outline" className="btn-outline gap-2"><ExternalLink className="w-4 h-4" /> Open diagram</Button>
        </a>
      </div>

      <Card className="card-surface">
        <CardContent className="p-4">
          <p className="text-[11px] uppercase tracking-wider font-bold text-slate-500 mb-3">Architecture Diagram</p>
          <div className="rounded-xl overflow-hidden border border-slate-200 bg-white">
            <img src={FILES.diagram} alt="Portal system architecture diagram" className="w-full h-auto" data-testid="arch-diagram-img" />
          </div>
          <a href={FILES.diagram} download className="inline-flex items-center gap-1.5 text-sm text-brand-navy hover:underline mt-3" data-testid="arch-download-diagram">
            <Download className="w-3.5 h-3.5" /> Download diagram (PNG)
          </a>
        </CardContent>
      </Card>

      <Card className="card-surface">
        <CardContent className="p-5">
          <p className="text-[11px] uppercase tracking-wider font-bold text-slate-500 mb-2">What's inside</p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 text-sm text-slate-600 list-disc list-inside">
            <li>Overview & technology stack</li>
            <li>3-layer system architecture</li>
            <li>Frontend page structure</li>
            <li>Backend / API domains</li>
            <li>MongoDB data model (collections)</li>
            <li>Authentication & security</li>
            <li>Third-party integrations</li>
            <li>Environments & deployment</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default ArchitectureTab;
